import React, { useEffect } from 'react';
import styles from './AboutUs.module.css';
import teamImage from '../assets/team_collaboration.jpg'; // Example professional team image
import usePageTracking from '../components/UsePageTracking';

function PrivacyPolicy() {

  usePageTracking();

  return (
    <div className={styles.aboutUsPage}>

      <section className={styles.ourStory}>
        <div className={styles.storyContent}>
          <h2>Privacy Policy</h2>
          <p>This Privacy Policy describes how Talk2Board AI & Data Consulting ("we," "us," or "our") collects, uses, and discloses your information when you visit our website, use our services, or interact with us. We are committed to protecting your privacy and handling your data with care and transparency.</p>
          <ol>
               <li> <h4> Information We Collect </h4>

               <p> We collect information to provide and improve our services to you. The types of information we may collect include: </p>

               <ul>
                  <li> <b> Personal Identification Information:</b> This includes your name, email address, phone number, and job title when you contact us, request a consultation, or subscribe to our newsletter. </li>

                  <li> <b> Business Information:</b> Information about your company, its goals, and challenges, which you provide to us to help us understand your needs. </li>

                  <li> <b> Technical Data: </b> We automatically collect data about your device and how you interact with our website, such as your IP address, browser type, pages visited, and time spent on our site. We use cookies and similar technologies for this purpose. </li>

               </ul> </li>

               <br/>

               <li> <h4> How We Use Your Information </h4>

               <p> We use the information we collect for the following purposes: </p>

               <ul>
                  <li> <b> To Provide Our Services: </b> To communicate with you, respond to your inquiries, and deliver the consulting services you have contracted us for. </li>

                  <li> <b> To Improve Our Website: </b> To analyze website traffic, user behavior, and to enhance the user experience and functionality of our site. </li>

                  <li> <b> For Marketing and Communication: </b> To send you updates, newsletters, and marketing materials about our services, which you can opt out of at any time. </li>

                  <li> <b> To Comply with Legal Obligations: </b> To meet our legal and regulatory requirements. </li>

               </ul> </li>

               <br/>

               <li> <h4> How We Share Your Information </h4>

               <p> We do not sell, rent, or trade your personal information. We may share your information with: </p>

               <ul>
                  <li> <b> Service Providers: </b> Trusted third parties who perform services on our behalf, such as website hosting, analytics, and marketing tools. These providers are bound by confidentiality agreements. </li>

                  <li> <b> Legal Requirements: </b> If required by law, we may disclose your information to comply with a subpoena, court order, or other legal process. </li>

                  <li> <b> Business Transfers: </b> In the event of a merger, acquisition, or sale of assets, your information may be transferred to the new owner as part of the transaction. </li>

               </ul> </li>

               <br/>

               <li> <h4> Data Security </h4> </li>

               <p> We take reasonable measures to protect your information from unauthorized access, use, or disclosure.
               We use industry-standard security protocols and technologies to safeguard your data. However, no method of transmission
               over the internet or electronic storage is 100% secure, so we cannot guarantee absolute security. </p>

               <br/>

               <li> <h4> Your Rights </h4> </li>

               <p> Depending on your jurisdiction, you may have the right to: </p>

               <ul>

                   <li> <b> Access: </b> Request a copy of the personal information we hold about you. </li>

                   <li> <b> Correction: </b> Ask us to correct any inaccurate or incomplete information. </li>

                   <li> <b> Erasure: </b> Request that we delete your personal information. </li>

                   <li> <b> Object: </b> Object to the processing of your personal data.  </li>

                   <li> <b> Data Portability: </b> Request that we transfer your information to another organization.  </li>

               </ul>

               <p> To exercise any of these rights, please contact us using the information provided below. </p>

               <br/>

               <li> <h4> Changes to this Policy </h4> </li>

               <p> We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically. </p>

               <li> <h4> Contact Us </h4> </li>

               <p> If you have any questions or concerns about this Privacy Policy, please contact us at: </p>
               <ul>
               <li> <b> Email: </b> privacy@talk2board.com </li>
               <li> <b> Date: </b> 2025-08-04 </li>

               </ul>
          </ol>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;